import { useStaticQuery, graphql } from 'gatsby'

export const useOurServicesMenuQuery = () => {
  const { allWpMenuItem } = useStaticQuery(graphql`
    query OurServicesMenuQuery {
      allWpMenuItem(filter: { parentDatabaseId: { eq: 0 }, locations: { eq: SERVICES_MENU } }) {
        nodes {
          menu {
            node {
              name
            }
          }
          label
          path
          menuIcons {
            icon {
              localFile {
                publicURL
              }
            }
          }
          childItems {
            nodes {
              label
              path
              menuIcons {
                icon {
                  localFile {
                    publicURL
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
  return allWpMenuItem
}
